import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "29",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F0F0F0",
      d: "M14.934 0A14.36 14.36 0 0 0 1.737 8.645c2.166-.93 4.231-1.106 6.145-.754 3.073.553 5.743 2.437 7.959 4.8 1.385 1.457 3.072 3.04 4.91 3.367 3.678.628 7.128-3.97 3.073-4.875 3.577-.176 2.746 4.171-.83 5.302-1.562.503-2.998.402-4.282 0-1.31-.427-2.494-1.18-3.627-2.06-2.443-1.885-4.634-3.393-7.052-3.393-2.266 0-4.634 1.282-7.454 4.7.05.552.15 1.105.252 1.658 2.014-1.985 3.777-2.89 5.44-3.091 1.788-.201 3.374.452 4.885 1.483 1.688 1.156 3.274 2.437 5.264 3.116 2.191.754 4.483.527 7.858-1.81-1.763 1.458-3.274 2.337-4.685 2.815s-2.695.528-3.979.276c-2.292-.452-3.954-2.06-6.296-2.362-1.31-.176-2.594.15-3.778.905-1.058.678-2.065 1.683-2.997 2.965.252.427.554.855.856 1.257 1.738-1.986 3.703-3.066 6.095-2.212 1.26.453 1.965 1.483 3.148 1.986q1.889.791 4.534-.377c-1.562 1.206-3.148 1.91-4.81 1.507-1.386-.326-2.091-1.306-3.778-1.03-.806.126-1.587.528-2.292 1.231a10 10 0 0 0-.907 1.056 14.32 14.32 0 0 0 9.545 3.619c7.959 0 14.38-6.434 14.38-14.35C29.315 6.434 22.894 0 14.935 0"
    }, null, -1)
  ])))
}
export default { render: render }